import React from "react";
import * as Icon from "react-feather";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import ToolsSelect from "../kit/ToolsSelect";

class AddClassificationModal extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			name: "",
			tax: "",
		};
	}

	onAddClicked = () => {
		const { onAdd, onClose } = this.props;

		const name = this.state.name.trim();
		if (!name) return;

		onAdd({ name, tax: this.state.tax });
		onClose();
	};

	renderFooter = () => {
		const { onClose } = this.props;
		const canAdd = this.state.name.trim() !== "";

		return (
			<>
				<span />
				<span className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Cancel</button>
					<button type="button" className="tk-button tk-button--primary" onClick={this.onAddClicked} disabled={!canAdd}>
						<Icon.Plus size={16} />
						Add
					</button>
				</span>
			</>
		);
	};

	render() {
		const { taxOptions, onClose } = this.props;
		const { name, tax } = this.state;

		const taxChoices = [{ value: "", label: "— No default —" }, ...taxOptions.map(taxOption => ({ value: taxOption, label: taxOption }))];

		return (
			<ToolsModal open={true} onClose={onClose} title="Add classification" width={440} footer={this.renderFooter()}>
				<div className="tk-form-field">
					<div className="tk-form-label">Account name</div>
					<input
						className="tk-input"
						value={name}
						onChange={e => this.update({ name: e.target.value })}
						placeholder="e.g. Office Supplies"
						autoFocus
					/>
				</div>
				<div className="tk-form-field">
					<div className="tk-form-label">Default tax</div>
					<ToolsSelect
						value={tax}
						options={taxChoices}
						onChange={selectedTax => this.update({ tax: selectedTax })}
						placeholder="— No default —"
					/>
					{taxOptions.length === 0 && <div className="tk-form-help">Select a province in step 3 to see tax options.</div>}
				</div>
			</ToolsModal>
		);
	}
}

export default AddClassificationModal;
